import { LayoutSchema } from '@updater/ui-informant';
import {
  INTERNET_USAGE_QUESTION,
  INTERNET_USERS_QUESTION,
} from '@updater/ui-widgets';

/**
 * The quiz's screens, in the order the Moving App asks them. Headings come
 * from the shared questions so the two products cannot drift apart again.
 */
export const merchandisingLayoutSchema: LayoutSchema = {
  basePath: '/provider/quiz/',
  screens: [
    {
      name: 'internet-users',
      route: 'internet-users',
      heading: INTERNET_USERS_QUESTION.heading,
      subHeading: INTERNET_USERS_QUESTION.subHeading,
      nextButtonText: 'Continue',
      fields: ['internetUsers'],
    },
    {
      name: 'internet-usage',
      route: 'internet-usage',
      heading: INTERNET_USAGE_QUESTION.heading,
      subHeading: INTERNET_USAGE_QUESTION.subHeading,
      nextButtonText: 'Continue',
      fields: ['internetUsage'],
    },
  ],
};
